// 업무 바로가기 표시 규칙 — 레일 · 더보기 · 바로가기 화면이 같은 모양을 쓰게 한다.

/** 그룹 표시 순서. 목록에 없는 그룹은 뒤에 붙는다. */
export const LINK_GROUPS = ['운영 도구', '소통·일정', '문서', '웹사이트']

/**
 * 그룹 → 아이콘 타일 색조. 그룹마다 색이 같아야 "파란 건 운영 도구" 로 눈이 먼저 찾는다.
 * 모르는 그룹은 회색이다 — 이름 해시로 색을 돌리면 그룹이 늘 때마다 기존 색이 바뀐다.
 */
const GROUP_TONE = { '운영 도구': 'primary', '소통·일정': 'success', 문서: 'warning', 웹사이트: 'violet' }
export const linkTone = (group) => GROUP_TONE[group] || 'muted'

/**
 * 아이콘 자리 글자. 사내 도구 이름이 전부 '이루다…' 로 시작해서 첫 글자만 따면
 * 타일이 전부 '이' 가 된다. 회사·브랜드 접두어를 걷어낸 뒤 첫 글자를 쓴다
 * (상담 장부의 icTxt 와 같은 규칙).
 */
export function linkInitial(link) {
  const name = String(link?.name || '?').trim()
  const rest = name.replace(/^(이루다(랩|원|ONE)?|빌라드엘리|키우다랩)\s*/i, '')
  return (rest || name).charAt(0).toUpperCase()
}

export function linkHost(url) {
  try {
    return new URL(url).host.replace(/^www\./, '')
  } catch (e) {
    return url || ''
  }
}

/** [{ group, links }] — 그룹 안은 sortOrder 순 */
export function groupLinks(links) {
  const sorted = [...(links || [])].sort((a, b) => (a.sortOrder ?? 999) - (b.sortOrder ?? 999) || a.id - b.id)
  const names = [...new Set([...LINK_GROUPS, ...sorted.map((l) => l.groupName || '기타')])]
  return names
    .map((group) => ({ group, links: sorted.filter((l) => (l.groupName || '기타') === group) }))
    .filter((g) => g.links.length)
}
